<div
  (mouseover)="onMouseOver()"
  (mouseout)="onMouseOut()"
  cdkOverlayOrigin
  #trigger="cdkOverlayOrigin"
>
  {{ row()?.memberCount }}
</div>
<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="trigger"
  [cdkConnectedOverlayOpen]="isOpen()"
>
  <mat-card class="tooltip-list p-6" (mouseover)="onMouseOver()" (mouseout)="onMouseOut()">
    @for (collarId of sortedCollars(); track collarId) {
      <div class="tooltip-list__item" [ngClass]="roleClass(collarId)">
        {{ collarId }}
      </div>
    }
  </mat-card>
</ng-template>
